module.exports = __webpack_public_path__ + "img/TheoX.99e9218.png";